(function () {
	'use strict';


	const lenis = new Lenis()

		lenis.on('scroll', (e) => {
		  console.log(e)
		})

		function raf(time) {
		  lenis.raf(time)
		  requestAnimationFrame(raf)
		}

		requestAnimationFrame(raf)

	// Switching to mobile: https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/onchange
	// const isMobile = window.matchMedia(
	// 	'(max-width: ' + getComputedStyle(document.body).getPropertyValue('--custom--media-max-width--sm') + ')'
	// );
	// const navigationResponsiveContainer = document.querySelector(
	// 	'.site-header .wp-block-navigation__responsive-container'
	// );
	// isMobile.onchange = (e) => {
	// 	if (e.matches) {
	// 		// <= Mobile
	// 	} else {
	// 		// > Mobile
	// 		// Autoclose header nav container if modal is open and browser window gets resized.
	// 		if (
	// 			document.body.contains(navigationResponsiveContainer) &&
	// 			navigationResponsiveContainer.classList.contains('is-menu-open')
	// 		) {
	// 			document.querySelector('.site-header .wp-block-navigation__responsive-container-close').click();
	// 		}
	// 	}
	// };

	// // Style password protected post form.
	// const passwordButton = document.querySelector('.post-password-form [type="submit"]');
	// if (document.body.contains(passwordButton)) {
	// 	const passwordButtonWrapper = document.createElement('div');
	// 	passwordButtonWrapper.classList.add('wp-block-button');
	// 	passwordButton.parentNode.insertBefore(passwordButtonWrapper, passwordButton);
	// 	passwordButtonWrapper.appendChild(passwordButton);

	// 	passwordButton.classList.add('wp-block-button__link');
	// }

	const myModal = new HystModal({
	    linkAttributeName: "data-hystmodal",
		//settings (optional). see API
	});

	document.addEventListener("DOMContentLoaded", (event) => {
	  gsap.registerPlugin(ScrollTrigger)
	  // gsap code here!

	  const animations = gsap.utils.toArray('.is-style-feature-image');

	  animations.forEach(ani => {
		  gsap.from(ani, {
		  	  duration: 1,
			  "--a": "-100px",
			  "--b": "-50px",
			  "--c": 0,
			  "--d": "50px",
			  ease: "power4.inOut",
			  scrollTrigger: {
			    markers: false,
			    start: "10% 60%",
			    end: "80% 60%",
			    //scrub: true,
			    trigger: ani,
			  }
			});
		  });


	   	gsap.defaults({ease: "power3"});
		gsap.set(".animate", {y: 50, opacity: 0});

		ScrollTrigger.batch(".animate", {
		  interval: 0.5, // time window (in seconds) for batching to occur. 
		//  batchMax: 3,   // maximum batch size (targets)
		  onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
		  onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 100, overwrite: true})
		  // you can also define things like start, end, etc.
		});

		gsap.set(".animate-multiple div", {y: 50, opacity: 0});

		ScrollTrigger.batch(".animate-multiple div", {
		  interval: 0.5, // time window (in seconds) for batching to occur. 
		//  batchMax: 3,   // maximum batch size (targets)
		  onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
		  onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 100, overwrite: true})
		  // you can also define things like start, end, etc.
		});

		gsap.set(".wp-block-post", {y: 50, opacity: 0});

		ScrollTrigger.batch(".wp-block-post", {
		  interval: 0.5, // time window (in seconds) for batching to occur. 
		//  batchMax: 3,   // maximum batch size (targets)
		  onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
		  onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
		  //onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 100, overwrite: true})
		  // you can also define things like start, end, etc.
		});

		//ScrollTrigger.addEventListener("refreshInit", () => gsap.set(".animate", {y: 0}));

	   // const boxes = gsap.utils.toArray('.animate');

	// 	boxes.forEach((box, i) => {
	// 	  const anim = gsap.fromTo(box, 
	// 	  	{autoAlpha: 0, y: 50}, 
	// 	  	{duration: 1, autoAlpha: 1, y: 0}
	// 	  );
	// 	  ScrollTrigger.create({
	// 	    trigger: box,
	// 	    animation: anim,
	// 	    toggleActions: 'play none none none',
	// 	    once: true,
	// 	  });
	// 	});

	   }); // end of documentloaded


})();
